<a class="username" [routerLink]="profileUrl">@{{user.username}}</a>

<span matTooltip="This is a verified official account" *ngIf="tag === 'official'" class="official tag">Official</span>
